import './polyfills/element-closest.js';
import { renderOnLayer, Layers, AnimationTypes, LayerAnimations } from '@doordash/component-layer-manager';
import FocusLock from '@doordash/component-focus-lock';
import ModalContentWithUniqueIdAndForwardedRef from './ModalContent.js';
import { FillScreen as FillScreen$1, OverlayPositioner } from './styles.js';
import Overlay from '@doordash/component-overlay';
import PropTypes from 'prop-types';
import React from 'react';
import ScrollLock from './ScrollLock.js';
import { ThemingContext } from '@doordash/design-language';
import { useMediaQuery } from '@doordash/utilities';
import { initialFocusAttribute } from './constants.js';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ModalPositioner = function ModalPositioner(_ref) {
  var shouldAnimate = _ref.shouldAnimate,
      props = _objectWithoutProperties(_ref, ["shouldAnimate"]);

  var prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  if (shouldAnimate && !prefersReducedMotion) {
    return /*#__PURE__*/React.createElement(LayerAnimations.SlideDown, _extends({
      component: FillScreen$1
    }, props));
  }

  return /*#__PURE__*/React.createElement(LayerAnimations.None, _extends({
    component: FillScreen$1
  }, props));
};

ModalPositioner.propTypes = {
  shouldAnimate: PropTypes.bool.isRequired
};

var FillScreen = function FillScreen(_ref2) {
  var shouldAnimate = _ref2.shouldAnimate,
      props = _objectWithoutProperties(_ref2, ["shouldAnimate"]);

  var prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  if (shouldAnimate && !prefersReducedMotion) {
    return /*#__PURE__*/React.createElement(LayerAnimations.Fade, _extends({
      component: FillScreen$1
    }, props));
  }

  return /*#__PURE__*/React.createElement(LayerAnimations.None, _extends({
    component: FillScreen$1
  }, props));
};

FillScreen.propTypes = {
  shouldAnimate: PropTypes.bool.isRequired
};

var Modal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Modal, _React$PureComponent);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getInitialFocusElement", function (container) {
      // If default header is used, there will be two elements with `[${initialFocusAttribute}]` to,
      // need to grab the one without `aria-hidden=false`
      var element = container.querySelector("[".concat(initialFocusAttribute, "]:not([aria-hidden=\"true\"]"));

      if (!element) {
        // This is a temporary "break-glass" fix for a scenario where a dev has not passed in a `title` to make sure we
        // are at least always passing focus to the modal.
        // Once we migrate to TS, this can be removed as we can more effectively ensure a `title` will always be present
        element = container.querySelector("[".concat(initialFocusAttribute, "]"));
      }

      return element;
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onEnterComplete = _this$props.onEnterComplete,
          onCloseComplete = _this$props.onCloseComplete,
          inProp = _this$props["in"],
          shouldCloseOnOverlayClick = _this$props.shouldCloseOnOverlayClick,
          shouldAnimate = _this$props.shouldAnimate,
          props = _objectWithoutProperties(_this$props, ["onEnterComplete", "onCloseComplete", "in", "shouldCloseOnOverlayClick", "shouldAnimate"]);

      return /*#__PURE__*/React.createElement(FillScreen$1, null, /*#__PURE__*/React.createElement(FillScreen, {
        "in": inProp,
        shouldAnimate: shouldAnimate
      }, /*#__PURE__*/React.createElement(OverlayPositioner // Prevent focus from leaving the modal when the overlay click does not close the modal
      , {
        onMouseDown: function onMouseDown(event) {
          return !shouldCloseOnOverlayClick && event.preventDefault();
        }
      }, /*#__PURE__*/React.createElement(Overlay, {
        isVisible: true,
        onClick: shouldCloseOnOverlayClick ? this.props.onClose : null
      }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalPositioner, {
        "in": inProp,
        onEntered: onEnterComplete,
        onExited: onCloseComplete,
        shouldAnimate: shouldAnimate
      }, /*#__PURE__*/React.createElement(FocusLock, {
        getInitialFocusElement: this.getInitialFocusElement
      }, /*#__PURE__*/React.createElement(ModalContentWithUniqueIdAndForwardedRef, props)), /*#__PURE__*/React.createElement(ScrollLock, null))));
    }
  }]);

  return Modal;
}(React.PureComponent);

_defineProperty(Modal, "contextType", ThemingContext);

_defineProperty(Modal, "propTypes", {
  "in": PropTypes.bool,
  onClose: PropTypes.func,
  onEnterComplete: PropTypes.func,
  onCloseComplete: PropTypes.func,
  shouldCloseOnEscapePress: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
  shouldAnimate: PropTypes.bool,
  useHairlineDividers: PropTypes.bool
});

_defineProperty(Modal, "defaultProps", {
  shouldCloseOnOverlayClick: true
});

var RenderedModal = renderOnLayer(Layers.Modal, Modal, {
  AnimationType: AnimationTypes.Custom
});
RenderedModal.HeaderAlignment = ModalContentWithUniqueIdAndForwardedRef.HeaderAlignment;
RenderedModal.Sizes = ModalContentWithUniqueIdAndForwardedRef.Sizes;
RenderedModal.CloseButtonSides = ModalContentWithUniqueIdAndForwardedRef.CloseButtonSides;
RenderedModal.defaultProps = _objectSpread(_objectSpread({}, ModalContentWithUniqueIdAndForwardedRef.defaultProps), {}, {
  shouldAnimate: true,
  shouldCloseOnOverlayClick: true
});

export { RenderedModal as default };
